module.exports = __webpack_public_path__ + "media/images/landing/1-be712fde0f656f2b1afc1cbe123de351.png";